<template>
    <div v-if="IsFiltered" class="Keikakumeisai_ProductEntry">
        <div class="Keikakumeisai_ProductBasicInfo" @click="()=>{OpenKeikakumeisaiProduct();}">
            <div class="Keikakumeisai_IconUnfoldContainer"><img src="../assets/Icon_Unfold.svg" :class="{'Keikakumeisa_IconUnfolded': IsUnfold}" /></div>
            <div class="Keikakumeisai_ProductName" :title="ProductInfo.productName">{{ this.ProductInfo.productName }}</div>
            <div class="Keikakumeisai_ProductBasic"><div>出荷時期</div> <div>{{ this.ReleaseCount }}</div> </div>
            <!-- <div class="Keikakumeisai_ProductBasic"><div>売上日</div> <div>{{ this.FormatSalesDate(this.ProductInfo.salesDate) }}</div></div> -->
            <div class="Keikakumeisai_ProductBasic"><div>受注数</div> <div :class="{NegativeCurrency: this.ProductTotalAmount < 0}">{{ this.$FormatNumber(this.ProductTotalAmount) }}</div></div>
            <div class="Keikakumeisai_ProductBasic"><div>売上</div> <div :class="{NegativeCurrency: this.ProductTotalSales < 0}">{{ this.$FormatCurrency(this.ProductTotalSales) }}</div></div>
            <div class="Keikakumeisai_ProductBasic"><div>利益</div> <div :class="{NegativeCurrency: this.ProductTotalProfit < 0}">{{ this.$FormatCurrency(this.ProductTotalProfit) }}</div></div>
        </div>
        <div :class="{'Keikakumeisai_DataContainer': true, Keikakumeisai_DataContainer_Open: IsUnfold}">
            <div class="Keikakumeisai_ProductSubInfoContainer">
                <div class="Keikakumeisai_ProductSubInfo" @click="OnClickFactory(this.ProductInfo.factory)">{{ this.ProductInfo.factory }}</div>
                <div class="Keikakumeisai_ProductSubInfo" @click="OnClickBrand(this.ProductInfo.brand)">{{ this.ProductInfo.brand }}</div>
                <div class="Keikakumeisai_ProductSubInfo" @click="OnClickSeries(this.ProductInfo.series)">{{ this.ProductInfo.series }}</div>
            </div>
            <div class="Keikakumeisai_HanbaisakiContainer">
                <!-- <KeikakumeisaiHanbaisaki v-for="entry in ProductInfo.Data" :key="entry.hanbaisaki" :-HanbaisakiInfo="entry" /> -->
                <KeikakumeisaiStylenumber v-for="entry in ProductInfo.styleNumbers" :key="entry.productCode" :-ProductData="entry" />
            </div>
        </div>
    </div>
</template>

<script>
// import KeikakumeisaiHanbaisaki from './KeikakumeisaiHanbaisaki.vue'
import KeikakumeisaiStylenumber from './KeikakumeisaiStylenumber.vue';
export default
{
    components:{
        // KeikakumeisaiHanbaisaki,
        KeikakumeisaiStylenumber,
    },
    props: {
        ProductInfo: Object,
        IsFiltered: Boolean,
        OnClickFactory: Function,
        OnClickBrand: Function,
        OnClickSeries: Function,
    },
    computed:{
        ProductTotalAmount(){
            let result = 0;

            for (let i = 0; i < this.ProductInfo.styleNumbers.length; i++)
            {
                const s = this.ProductInfo.styleNumbers[i];

                for (let j = 0; j < s.Data.length; j++)
                {
                    result += s.Data[j].amount;
                }
            }

            return result;
        },
        ReleaseCount()
        {
            let highest = 0;
            for (let i = 0; i < this.ProductInfo.styleNumbers.length; i++)
            {
                const s = this.ProductInfo.styleNumbers[i];

                for (let j = 0; j < s.Data.length; j++)
                {
                    highest = Math.max(highest, s.Data[j].release_number);
                }
            }

            return highest;
        },
        ProductTotalSales(){
            let result = 0;

            for (let i = 0; i < this.ProductInfo.styleNumbers.length; i++)
            {
                const s = this.ProductInfo.styleNumbers[i];

                for (let j = 0; j < s.Data.length; j++)
                {
                    result += s.Data[j].sales;
                }
            }

            return result;
        },
        ProductTotalProfit(){
            let result = 0;

            for (let i = 0; i < this.ProductInfo.styleNumbers.length; i++)
            {
                const s = this.ProductInfo.styleNumbers[i];

                for (let j = 0; j < s.Data.length; j++)
                {
                    result += s.Data[j].profit;
                }
            }

            return result;
        }
    },
    methods:{
        OpenKeikakumeisaiProduct()
        {
            this.IsUnfold = !this.IsUnfold;
        },
        FormatSalesDate(salesDate)
        {
            if (typeof(salesDate) !== typeof(Date))
            {
                salesDate = new Date(salesDate);
            }
            return `${salesDate.getFullYear()}年${(salesDate.getMonth() + 1).toString().padStart(2,'0')}月`;
        },
    },
    data(){
        return{
            IsUnfold: false,
        }
    }
}

</script>

<style>
.NegativeCurrency
{
    color: rgb(202, 17, 17);
}

.Keikakumeisai_ProductEntry
{
    border: 1px solid #ccc;
    margin-bottom: 8px;
    padding: 10px 25px 10px 5px;
}

.Keikakumeisai_ProductEntry .Keikakumeisai_ProductBasicInfo
{
    cursor: pointer;
}

.Keikakumeisai_ProductBasicInfo
{
    display: flex;
    align-items: center;
}

.Keikakumeisai_IconUnfoldContainer
{
    width: 18px;
    height: 18px;
    padding: 0px 8px;
    cursor: pointer;
}

.Keikakumeisai_IconUnfoldContainer img
{
    width: 80%;
    height: 80%;
    pointer-events: none;
    transition: 0.2s;
    -webkit-transition: 0.2s;
    -moz-transition: 0.2s;
}

.Keikakumeisa_IconUnfolded
{
    transform: rotate(180deg);
}

.Keikakumeisai_ProductName
{
    margin-left: 10px;
    flex: 1.0;
    white-space: nowrap;
    overflow-x: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
}

.Keikakumeisai_ProductBasic
{
    flex: 0.5;
    display: flex;
}

.Keikakumeisai_ProductBasic div:first-of-type
{
    flex: 0.8;
    text-align: right;
    color: #888;
    align-content: center;
    font-size: 0.85rem;
}

.Keikakumeisai_ProductBasic div + div
{
    flex: 1.0;
    text-align: right;
    align-content: center;
}

.Keikakumeisai_DataContainer
{
    margin-left: 44px;
    max-height: 0px;
    overflow: hidden;
    transition: 0.2s;
    -webkit-transition: 0.2s;
    -moz-transition: 0.2s;
}

.Keikakumeisai_DataContainer_Open
{
    max-height: 9999px;
}

.Keikakumeisai_ProductSubInfoContainer
{
    display: flex;
    padding: 10px 0px;
}

.Keikakumeisai_ProductSubInfoContainer div
{
    background-color: rgb(227, 232, 231);
    border-radius: 20px;
    font-size: 1.1rem;
    padding: 5px 8px;
    place-content: center;
    display: grid;
    cursor: pointer;
    transition: 0.2s;
    -moz-transition: 0.2s;
    -webkit-transition: 0.2s;
}

.Keikakumeisai_ProductSubInfoContainer div:hover
{
    background-color: #888;
}

.Keikakumeisai_ProductSubInfoContainer div:first-of-type
{
    margin-left: auto;
}

.Keikakumeisai_ProductSubInfoContainer div + div
{
    margin-left: 8px;
}
</style>